"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var ripple_1 = require("@material/ripple");
require("../icon");
var dom_ready_1 = require("../util/dom-ready");
//@ts-ignore
require("../theme.ts");
var Fab = /** @class */ (function (_super) {
    __extends(Fab, _super);
    function Fab() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Fab.prototype.installed = function () {
        var _this = this;
        dom_ready_1.domReady(function () {
            _this.update();
        });
        if (this.props.ripple) {
            new ripple_1.MDCRipple(this.shadowRoot.querySelector('.mdc-fab'));
        }
    };
    Fab.prototype.render = function (props) {
        var lb = this.normalizedNodeName ? props.children[0] : this.innerHTML;
        var i = props.icon && omi_1.h("i", { class: "mdc-fab__icon material-icons" }, props.icon);
        return (omi_1.h("button", __assign({}, omi_1.extractClass(props, 'mdc-fab', {
            'mdc-fab--mini': props.mini,
            'mdc-fab--extended': lb
        }), { "aria-label": props.icon ? props.icon.split('_')[0] : lb }),
            !props.iconRight && i,
            lb && omi_1.h("span", { class: "mdc-fab__label" }, lb),
            props.iconRight && i));
    };
    Fab.css = css;
    Fab.propTypes = {
        ripple: Boolean,
        mini: Boolean,
        iconRight: Boolean,
        icon: String
    };
    Fab = __decorate([
        omi_1.tag('m-fab')
    ], Fab);
    return Fab;
}(omi_1.WeElement));
exports.default = Fab;
